import { Panel } from "../Panel"
import { GlobeView } from "../GlobeView"

export function GlobePanel() {
  return (
    <Panel title="Global network" helpText="Flights, ships, incidents and fleet. Synthetic ships are labeled in the map.">
      <div className="globe-panel-content">
        <GlobeView embedded />
      </div>
    </Panel>
  )
}
